import { memo, useEffect, useState } from "react";
import { apiGetDebtors } from "../../api/dashboardApi";
import DashboardPeopleList from "../Shared/Dashboard/DashboardPeopleList";
import { useAppDispatch, useAppSelector } from "store/store";
import { Box, Skeleton, Typography } from "@mui/material";
import { RawBox } from "components/Shared/Dashboard/styled";
import { BoxUpper } from "components/Shared/BoxUpper";
import RefreshIcon from "assets/icons/RefreshIcon";

const Debts = ({ title }: { title?: string }) => {
  const dispatch = useAppDispatch();
  const token = useAppSelector((x) => x.businessReducer.business?.token);
  const debtors = useAppSelector((x) => x.dashboardReducer.debtors);

  // useEffect(() => {
  //   if (token) dispatch(apiGetDebtors(token));
  // }, [token]);
  const onClick = () => {
    if (token) dispatch(apiGetDebtors(token,changeLoading))
  }
  const [isLoading, setLoading] = useState(false)
  const changeLoading = () => {
    setLoading(state => !state)
  }
  const count = debtors?.count as number;
  const totalPrice = debtors?.totalPrice as number;
  const arrayData = debtors?.debtors as any[];
  return arrayData ? (
    <DashboardPeopleList arrayData={arrayData} totalPrice={totalPrice} title={title} count={count} />
  ) :
  <RawBox>
  <BoxUpper title={`${title} (${0})`} />
  <Box 
    onClick={() => {
      onClick()
    }}
    sx={{
      position: 'relative',
      width: '100%', // Set your desired width
      height: 350, // Set your desired height
      display: 'flex',
      justifyContent: 'center',
      padding:"15px 24px",
      cursor: 'pointer',
      alignItems: 'center',
      // border: '1px solid #ccc', // Optional: for visual reference
    }}
  >
    <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
    <Typography
      variant="h6"
      sx={{
        position: 'absolute',
        color: '#747575', // Change color based on your skeleton background
      }}
    >
        نمایش اطلاعات
          </Typography>
   <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
                  <RefreshIcon scale={0.8} />
                </div>
    <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
                  <RefreshIcon scale={0.8} />
                </div>

  </Box>
</RawBox>;
};

export default memo(Debts);
